function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import { Event, Interface, Method } from '@central-products/transport-bus-common';

var WelcomeMessagesFlowInterface =
/*#__PURE__*/
function () {
  function WelcomeMessagesFlowInterface() {
    _classCallCheck(this, WelcomeMessagesFlowInterface);
  }

  _createClass(WelcomeMessagesFlowInterface, [{
    key: "start",
    value: function start(action) {
      throw new Error('Method is not implemented yet');
    }
  }, {
    key: "cancel",
    value: function cancel() {
      throw new Error('Method is not implemented yet');
    }
  }, {
    key: "uiDisplayed",
    value: function uiDisplayed() {
      throw new Error('Method is not implemented yet');
    }
  }, {
    key: "onStateChanged",
    value: function onStateChanged(callback) {
      throw new Error('Event is not implemented yet');
    }
  }]);

  return WelcomeMessagesFlowInterface;
}();

__decorate([Method('start'), __metadata("design:type", Function), __metadata("design:paramtypes", [Object]), __metadata("design:returntype", Promise)], WelcomeMessagesFlowInterface.prototype, "start", null);

__decorate([Method('cancel'), __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", Promise)], WelcomeMessagesFlowInterface.prototype, "cancel", null);

__decorate([Method('ui.displayed'), __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", Promise)], WelcomeMessagesFlowInterface.prototype, "uiDisplayed", null);

__decorate([Event('state.changed'), __metadata("design:type", Function), __metadata("design:paramtypes", [Function]), __metadata("design:returntype", Function)], WelcomeMessagesFlowInterface.prototype, "onStateChanged", null);

WelcomeMessagesFlowInterface = __decorate([Interface('common', 'ui.welcome.messages.flow')], WelcomeMessagesFlowInterface);
export default WelcomeMessagesFlowInterface;
//# sourceMappingURL=WelcomeMessagesFlowInterface.js.map